<template>
  <main id="home" :class="{ noGeo : this.$store.state.infoDay === null }">
    <HomeSearch />
    <HomeLoader v-if="!isReady" />
    <HomeResult v-if="isReady && this.infoDay"/>
  </main>
</template>

<script>

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
})

import HomeSearch from "../components/HomeSearch";
import HomeLoader from "../components/HomeLoader";
import HomeResult from "../components/HomeResult";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "Home",
  components: {
    HomeSearch,
    HomeLoader,
    HomeResult
  },
  data() {
    return {
      infoDaySave: null
    };
  },
  computed: {
    ...mapState(["isReady", "infoDay", "infoForeCast"])
  },
  mounted() {
    this.position();
    this.loading();
    this.sizeContent();
  },
  methods: {
    sizeContent() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    loading() {
      setTimeout(() => {
        this.$store.commit("updateContent", !this.isReady);
      }, 1500);
    },
    // Récupére la position automatiquement ainsi que les info de l'api weather
    position() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(position => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        axios
          .get(
            `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&lang=fr&units=metric&appid=8469952240e30855b481efa25df3d378`
          )
          .then(
            res => (
              (this.infoDaySave = res),
              this.$store.commit("updateWeather", this.infoDaySave.data.name,
              this.$store.commit("updateForeCast", { 
                'lat':this.infoDaySave.data.coord.lat,
                'lon':this.infoDaySave.data.coord.lon
                }
              ))
            )
          );
      });
      }
    }
  }
};
</script>
<style lang="scss">
@import "../scss/global";
@import "../scss/views/home";
</style>